import './App.css'
import * as React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import PrivateRoute from '../../helpers/PrivateRoute'
import { config } from '../../configs/config-firebase'
import * as firebase from 'firebase/app'
import Navigation from '../navigation/Navigation'
import Replay from '../replay/Replay'
import Schedule from '../schedule/Schedule'
import Teacher from '../teacher/Teacher'
import LiveStream from '../stream/LiveStream'
import Login from '../login/Login'
import Password from '../password/Password'
import DailyVideo from '../daily-video/Daily-video'
import Promocode from '../promocode/Promocode'

class App extends React.Component {

  public componentWillMount() {
    firebase.initializeApp(config)
  }

  public render() {
    return (
      <Router>
        <div className="App">
          <h1>Journey LIVE Mission control 🚀</h1>
          <Navigation />
          <Switch>
            <Route path="/login" component={Login} />
            <PrivateRoute path="/password" component={Password} />
            <PrivateRoute path="/replay" component={Replay} />
            <PrivateRoute path="/daily" component={DailyVideo} />
            <PrivateRoute path="/schedule" component={Schedule} />
            <PrivateRoute path="/teacher" component={Teacher} />
            <PrivateRoute path="/promocode" component={Promocode} />
            <PrivateRoute path="/" component={LiveStream} />
          </Switch>
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/app/App.tsx